import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {Grid, Typography, Button, Checkbox} from '@material-ui/core';
import { CustomForm } from '@components/Form/CustomForm';
import { SaveButton } from '@components/Button/SaveButton';
import { officeActions } from '@actions/office.actions';
import {alertActions} from "../../../actions/alert.actions";

export default function CreateOffice(props) {
    const { register, handleSubmit, reset } = useForm();
    const history = useHistory();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const dispatch = useDispatch();
    const office = useSelector(state => state.officeReducer);
    const officeReducer = useSelector(state => state.officeReducer.office);
    const companyId = props.location.state.companyId;
    const companies = useSelector(state => state.companyReducer.companies);
    const [keepData, setKeepData] = useState({
        label: undefined,
        main: false,
        owner: false,
        isCompanyOffice: false,
        contactPerson: {
            lastname: undefined,
            firstname: undefined,
            phone: undefined,
            email: undefined,
            job: undefined
        },
        accountingPerson: {
            lastname: undefined,
            firstname: undefined,
            phone: undefined,
            email: undefined,
            job: undefined
        },
        address: {
            street_name: undefined,
            street_number: undefined,
            zip_code: undefined,
            city: undefined,
            country: undefined
        },
        // METTRE AU MEME DATES QUE LE PREMIER SITES
        contractDate: {
            end: undefined,
            start: undefined
        },
        rate: 0,
        billingEmail: undefined,
        merchandiseWarehouse: undefined,
        limitAmountOfCapitals: 0,
        damageInsuranceNumber: undefined,
        damageInsuranceName: undefined,
        rcNumber: undefined,
        rcName: undefined,
    });
    const [showGoods, setShowGoods] = useState(false);

    const handleGoodsCheckboxChange = (event) => {
        setShowGoods(event.target.checked);
    };
    const [accountingForm, setAccountingForm] = useState({ lines: [] })

    useEffect(() => {
        const companySelected = companies.find((company) => company.id === companyId)

        if (companySelected && companySelected.accountingPerson) {
            const companyAccounting = companySelected.accountingPerson
            setAccountingForm({
                lines: [

                    [
                        { label: 'Nom de la personne de comptabilité', field: 'accountingPerson.lastname', data: companyAccounting.lastname },
                        { label: 'Prénom de la personne de comptabilité', field: 'accountingPerson.firstname', data: companyAccounting.firstname }
                    ],
                    [
                        { label: 'Téléphone de la personne de comptabilité', field: 'accountingPerson.phone', data: companyAccounting.phone },
                        { label: 'E-mail de la personne de comptabilité', field: 'accountingPerson.email', data: companyAccounting.email },
                        { label: 'Role de la personne de comptabilité', field: 'accountingPerson.job', data: companyAccounting.job }
                    ],
                    [
                        { label: 'Email de contact pour la facturation', field: 'billingEmail', type: 'email', data: keepData?.billingEmail },
                    ]
                ]
            })
        } else {
            setAccountingForm({
                lines: [

                    [
                        { label: 'Nom de la personne de comptabilité', field: 'accountingPerson.lastname', data: keepData.accountingPerson.lastname },
                        { label: 'Prénom de la personne de comptabilité', field: 'accountingPerson.firstname', data: keepData.accountingPerson.firstname }
                    ],
                    [
                        { label: 'Téléphone de la personne de comptabilité', field: 'accountingPerson.phone', data: keepData.accountingPerson.phone },
                        { label: 'E-mail de la personne de comptabilité', field: 'accountingPerson.email', data: keepData.accountingPerson.email },
                        { label: 'Role de la personne de comptabilité', field: 'accountingPerson.job', data: keepData.accountingPerson.job }
                    ],
                    [
                        { label: 'Email de contact pour la facturation', field: 'billingEmail', type: 'email', data: keepData?.billingEmail },
                    ]
                ]
            })

        }
    }, [companies, companyId, keepData, setAccountingForm])

    const [main, setMain] = useState(false)
    const [owner, setOwner] = useState(false)
    const [isCompanyOffice, setIsCompanyOffice] = useState(false)

    const form = {
        title: "Création du site",
        lines: [
            [
                { label: 'Site', field: 'label', data: keepData.label },
                { label: 'Siège social ', field: 'main', type: 'boolean', data: main, setData: (e) => setMain(e.target.checked) },
                { label: 'Site principal', field: 'owner', type: 'boolean', data: owner, setData: (e) => setOwner(e.target.checked) },
                { label: 'Site secondaire', field: 'isCompanyOffice', type: 'boolean', data: isCompanyOffice, setData: (e) => setIsCompanyOffice(e.target.checked) },
            ],
            [
                { label: 'Début du contrat d\'assurance', field: 'contractDate.start', type: 'date', data: keepData.contractDate.start },
                { label: 'Fin d\'échéance', field: 'contractDate.end', type: 'date', data: keepData.contractDate.end }
            ],
        ]
    }

    const addressForm = {
        lines: [
            [
                { label: 'Numéro de rue', field: 'address.street_number', data: keepData.address.street_number },
                { label: 'Nom de rue', field: 'address.street_name', data: keepData.address.street_name },
                { label: 'Code postal', field: 'address.zip_code', data: keepData.address.zip_code },
            ],
            [
                { label: 'Ville', field: 'address.city', data: keepData.address.city },
                { label: 'Pays', field: 'address.country', data: keepData.address.country },
            ],
        ]
    }

    const contactForm = {
        lines: [
            [
                { label: 'Nom de la personne de contact', field: 'contactPerson.lastname', data: keepData.contactPerson.lastname },
                { label: 'Prénom de la personne de contact', field: 'contactPerson.firstname', data: keepData.contactPerson.firstname },
            ],
            [
                { label: 'Téléphone de la personne de contact', field: 'contactPerson.phone', data: keepData.contactPerson.phone },
                { label: 'E-mail de la personne de contact', field: 'contactPerson.email', data: keepData.contactPerson.email },
                { label: 'Role de la personne de contact', field: 'contactPerson.job', data: keepData.contactPerson.job }
            ],
        ]
    }



    const depositForm = {
        lines: [
            [
                { label: 'Description', field: 'merchandiseWarehouse', type: 'string', data: keepData.merchandiseWarehouse },
            ],
            [
                { label: 'Taux annuel TTC (‰)', field: 'rate', data: keepData.rate },
                { label: 'Limite de capitaux des marchandises assurées', field: 'limitAmountOfCapitals', data: keepData.limitAmountOfCapitals },
            ],
            [
                { label: 'Numéro de contrat assurance dommage', field: 'damageInsuranceNumber', data: keepData.damageInsuranceNumber },
                { label: 'Nom compagnie pour Assurance Dommage ', field: 'damageInsuranceName', data: keepData.damageInsuranceName },
            ],
            [
                { label: 'Numéro de RC', field: 'rcNumber', data: keepData.rcNumber },
                { label: 'Nom compagnie pour RC ', field: 'rcName', data: keepData.rcName },
            ],
        ]
    }

    const onSubmit = (properties) => {
        if (
            properties.contactPerson.lastname !== '' &&
            properties.contactPerson.firstname !== '' &&
            properties.contactPerson.phone !== '' &&
            properties.contactPerson.email !== '' &&
            properties.contactPerson.job !== '' &&
            properties.address.street_number !== '' &&
            properties.address.street_name !== '' &&
            properties.address.zip_code !== '' &&
            properties.address.city !== '' &&
            properties.address.country !== ''
        ) {
            if (!showGoods) {
                properties.rate = properties.rate ?? 0;
                properties.limitAmountOfCapitals = properties.limitAmountOfCapitals ?? 0;
                properties.accountingPerson = {
                    lastname: '',
                    firstname: '',
                    phone: '',
                    email: '',
                    job: ''
                };
            } else {
                properties.rate = parseInt(properties.rate);
                properties.limitAmountOfCapitals = parseInt(properties.limitAmountOfCapitals);
            }
            properties.label = properties.label ?? keepData.label;
            properties.main = main;
            properties.owner = owner;
            properties.isCompanyOffice = isCompanyOffice;
            // properties.contactPerson.lastname = properties.contactPerson.lastname ?? keepData.contactPerson.lastname;
            // properties.contactPerson.firstname = properties.contactPerson.firstname ?? keepData.contactPerson.firstname;
            // properties.contactPerson.phone = properties.contactPerson.phone ?? keepData.contactPerson.phone;
            // properties.contactPerson.email = properties.contactPerson.email ?? keepData.contactPerson.email;
            properties.contactPerson.lastname = properties.contactPerson.lastname !== '' ? properties.contactPerson.lastname : keepData.contactPerson.lastname;
            properties.contactPerson.firstname = properties.contactPerson.firstname !== '' ? properties.contactPerson.firstname : keepData.contactPerson.firstname;
            properties.contactPerson.phone = properties.contactPerson.phone !== '' ? properties.contactPerson.phone : keepData.contactPerson.phone;
            properties.contactPerson.email = properties.contactPerson.email !== '' ? properties.contactPerson.email : keepData.contactPerson.email;
            properties.contactPerson.job = properties.contactPerson.job !== '' ? properties.contactPerson.job : keepData.contactPerson.job;
            // properties.contactPerson.job = properties.contactPerson.job ?? keepData.contactPerson.job;
            properties.address.street_number = properties.address.street_number ?? keepData.address.street_number;
            properties.address.street_name = properties.address.street_name ?? keepData.address.street_name;
            properties.address.zip_code = properties.address.zip_code ?? keepData.address.zip_code;
            properties.address.city = properties.address.city ?? keepData.address.city;
            properties.address.country = properties.address.country ?? keepData.address.country;
            properties.contractDate.start = properties.contractDate.start ?? keepData.contractDate.start;
            properties.contractDate.end = properties.contractDate.end ?? keepData.contractDate.end;
            properties.rate = parseInt(properties.rate);
            properties.limitAmountOfCapitals = parseInt(properties.limitAmountOfCapitals) ?? 0;
            properties.billingEmail = properties.billingEmail ?? '';
            properties.merchandiseWarehouse = properties.merchandiseWarehouse ?? '';
            properties.rcName = properties.rcName ?? keepData.rcName;
            properties.rcNumber = properties.rcNumber ?? keepData.rcNumber;
            properties.damageInsuranceNumber = properties.damageInsuranceNumber ?? keepData.damageInsuranceNumber;
            properties.damageInsuranceName = properties.damageInsuranceName ?? keepData.damageInsuranceName;

            dispatch(officeActions.create(companyId, properties));
            setKeepData(properties);
            reset({});
        }
    };



    const onClick = () => {
        history.goBack();
    }

    useEffect(() => {
        if (office.action === 'office/createSuccess') {
            dispatch(officeActions.clearSuccess());
            history.goBack();
        }
    }, [office, dispatch, history]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container style={{ margin: '50px 0' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-start">
                        <Grid item xs={1}></Grid>
                        <Grid item xs={9}>
                            <Typography variant="h6" fontWeight="fontWeightBold">
                                Création d'un site
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="outlined" onClick={onClick}>Retour</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="center">
                        <Grid item xs={10}>


                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <CustomForm title={''} lines={form.lines} register={register} />
                                </Grid>

                                <Grid item xs={12}>
                                    <CustomForm title={'Adresse'} lines={addressForm.lines} register={register} />
                                </Grid>

                                <Grid item xs={12}>
                                    <CustomForm title={'Contact'} lines={contactForm.lines} register={register} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Checkbox checked={showGoods} onChange={handleGoodsCheckboxChange} />
                                    <label>Afficher la partie Marchandises pour compte de Tiers et Comptabilité</label>
                                </Grid>
                                {showGoods && (
                                    <Grid item xs={12}>
                                        <CustomForm title={'Comptabilité'} lines={accountingForm.lines} register={register} />
                                    </Grid>
                                )}
                                {showGoods && (
                                    <Grid item xs={12}>
                                        <CustomForm title={'Marchandises'} lines={depositForm.lines} register={register} />
                                    </Grid>
                                )}
                            </Grid>

                        </Grid>
                        <Grid item xs={10} style={{ marginTop: 50 }}>
                            <Grid container justifyContent="center">
                                <SaveButton disabled={isButtonDisabled} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}